import { useEffect } from 'react';
import { SendTestMessage } from 'modules/templateEditor/common/Controls';
import { useSendTestMsgContext } from 'modules/templateEditor/context/SendTestMsgContext';
import { SendTestMsgModals } from 'modules/templateEditor/modals';
import { EmbeddedMessage } from 'constants/messageMediums';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';
import { CampaignState } from 'modules/domains/campaign';

export const CampaignSendTestModalAndTrigger = ({ campaign = {} as GraphQLCampaign }) => {
  const { onFetchLists } = useSendTestMsgContext();
  const { medium } = useTemplateQueryContext();
  const isCampaignFlow = !!campaign?.id;

  useEffect(() => onFetchLists(), []);

  /**
   * Until we have campaign ended eventing setup on the BE, using campaign state as a proxy to determine whether or not
   * to show proof counts is what we have to work with.
   * See https://github.com/Iterable/iterable-frontend/pull/14514#discussion_r1778874625 for more context.
   * Will be cleaned up/removed by https://iterable.atlassian.net/browse/MOB-9658
   */
  const isEligibility = medium === EmbeddedMessage;

  const isEligibilityCampaignEnded =
    isCampaignFlow &&
    isEligibility &&
    (campaign?.campaignState === CampaignState.Aborted ||
      campaign?.campaignState === CampaignState.Archived ||
      campaign?.campaignState === CampaignState.Finished);

  return (
    <div>
      <SendTestMessage isEligibilityCampaignEnded={isEligibilityCampaignEnded} />
      <SendTestMsgModals />
    </div>
  );
};
